// ヘッダー内の見た目位置に合わせて、開閉ボタンのtopを固定する
export function syncModalOpenButtonTop(): void {
  const openButton = document.querySelector<HTMLElement>(".js-modal-open");
  const headerInner = document.querySelector<HTMLElement>(".l-header__inner");
  if (!openButton || !headerInner) return;

  let rafId = 0;
  const updateTop = () => {
    // .l-header__inner の中央に、ボタンの中央が重なるように配置
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const innerRect = headerInner.getBoundingClientRect();
    const innerTop = innerRect.top + scrollTop;
    const centeredTop =
      innerTop + (innerRect.height - openButton.offsetHeight) / 2;
    const top = Math.max(0, centeredTop);
    openButton.style.top = `${top}px`;
    document.documentElement.style.setProperty("--modal-open-btn-top", `${top}px`);
  };
  const requestUpdateTop = () => {
    // 連続リサイズ時は最新フレームだけ反映してガタつきを防ぐ
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(updateTop);
  };

  // 初期表示と、レイアウトが変わるタイミングで再計算
  updateTop();
  window.addEventListener("resize", requestUpdateTop);
  window.addEventListener("orientationchange", requestUpdateTop);
  window.addEventListener("load", requestUpdateTop);
}
